module.exports = __webpack_public_path__ + "media/images/trust-icon-block-b5c7978d999dd028e6e3f0f47f85d1d7.svg";